/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPaidIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-paid"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.8Q9.75 22.8 7.79 21.95Q5.83 21.1 4.36 19.64Q2.9 18.18 2.05 16.21Q1.2 14.25 1.2 12Q1.2 9.75 2.05 7.78Q2.9 5.8 4.36 4.34Q5.83 2.88 7.79 2.04Q9.75 1.2 12 1.2Q14.25 1.2 16.23 2.04Q18.2 2.88 19.66 4.34Q21.13 5.8 21.96 7.78Q22.8 9.75 22.8 12Q22.8 14.25 21.96 16.21Q21.13 18.18 19.66 19.64Q18.2 21.1 16.23 21.95Q14.25 22.8 12 22.8ZM11.97 19.35Q11.97 19.35 12.21 19.35Q12.45 19.35 12.78 19.02Q13.1 18.7 13.1 18.23L13.1 18.05Q14.5 17.7 15.35 16.93Q16.2 16.15 16.2 14.6Q16.2 13.5 15.63 12.55Q15.05 11.6 13.2 10.95Q11.72 10.45 11.09 10.1Q10.45 9.75 10.45 9.15Q10.45 8.57 10.85 8.26Q11.25 7.95 12.05 7.95Q12.5 7.95 12.82 8.09Q13.15 8.22 13.38 8.47Q13.75 8.88 14.13 9.01Q14.5 9.15 14.85 9Q15.35 8.8 15.54 8.32Q15.72 7.85 15.47 7.45Q15.07 6.83 14.47 6.41Q13.88 6 13.15 5.95L13.15 5.78Q13.15 5.3 12.82 4.97Q12.5 4.65 12.03 4.65Q11.55 4.65 11.22 4.97Q10.9 5.3 10.9 5.78L10.9 5.95Q9.65 6.25 8.93 7.14Q8.2 8.03 8.2 9.15Q8.2 10.4 8.91 11.2Q9.63 12 11.05 12.5Q12.63 13.07 13.29 13.5Q13.95 13.93 13.95 14.6Q13.95 15.32 13.45 15.66Q12.95 16 12.15 16Q11.57 16 11.07 15.74Q10.57 15.47 10.25 14.93Q9.97 14.47 9.59 14.29Q9.2 14.1 8.78 14.25Q8.28 14.45 8.07 14.9Q7.88 15.35 8.1 15.82Q8.53 16.68 9.2 17.23Q9.88 17.77 10.85 18L10.85 18.23Q10.85 18.7 11.18 19.02Q11.5 19.35 11.97 19.35Z" fill={color} />
    </svg>
  );
}
